import { render, staticRenderFns } from "./Catalog.vue?vue&type=template&id=d74950d8&scoped=true"
import script from "./Catalog.vue?vue&type=script&lang=js"
export * from "./Catalog.vue?vue&type=script&lang=js"
import style0 from "./Catalog.vue?vue&type=style&index=0&id=d74950d8&prod&lang=css"
import style1 from "./Catalog.vue?vue&type=style&index=1&id=d74950d8&prod&lang=scss&scoped=true"
import style2 from "./Catalog.vue?vue&type=style&index=2&id=d74950d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74950d8",
  null
  
)

export default component.exports